import React, { useMemo, useContext } from 'react';

// DEPENDENCIES
import format from 'date-fns/format';

// CORE COMPONENTS
import Form from 'core/form/Form';

// GLOBAL HELPERS
import { ListContext } from 'helpers/getListData.js';

const CurrentDate = () => {
  const { preferences, updateFilters } = useContext(ListContext);

  const dateToday = useMemo(() => format(new Date(), 'PPPP'), []);
  const timeNow = useMemo(() => format(new Date(), 'p'), []);

  const handleToday = () => {
    updateFilters({
      ...preferences.filters,
      saleDate: Form.Date.OPTIONS.today.date
    })
  };

  return (
    <label className='mb-4'>
      <a className="text-blue" onClick={handleToday}>Today</a> is {dateToday} {timeNow}
    </label>
  );
};

export default CurrentDate;
